import { AppResource } from "../../../../types/resource.types";
import { RequestStatus } from "../types";

export const fetchRequestChangedTimes = async (record: any, status: string | null = "pending") => {
  try {
    let snapshot = record.ref.collection(AppResource.changedTimes).orderBy("createdAt", "desc").limit(1);

    snapshot = status ? await snapshot.where("status", "==", RequestStatus.pending).get() : await snapshot.get();
    if (!snapshot.empty) {
      return snapshot.docs[0].data();
    }
    return undefined;
  } catch (ex: any) {
    console.log(ex.message);
    return undefined;
  }
};
